import React from "react";
import { motion } from "framer-motion";
import { Droplets, Users, Newspaper, GraduationCap } from "lucide-react";
import { fadeUp, stagger, VIEWPORT_LG, VIEWPORT_SM } from "./motion";

const SERVICES = [
  {
    id: "liquidity",
    icon: Droplets,
    num: "01",
    title: "Liquidity & Strategic Partnerships",
    body:
      "Origination and stewardship of strategic broker relationships and liquidity channels — connecting institutions to the counterparties and infrastructure that matter.",
    span: "md:col-span-7",
  },
  {
    id: "b2b",
    icon: Users,
    num: "02",
    title: "Introducing-Broker & B2B Sourcing",
    body:
      "Sourcing, onboarding and long-term maintenance of introducing-broker and B2B client relationships, backed by a disciplined pipeline.",
    span: "md:col-span-5",
  },
  {
    id: "intelligence",
    icon: Newspaper,
    num: "03",
    title: "Market Intelligence & Commentary",
    body:
      "Recurring institutional insight across FX, indices, futures and digital assets — macro outlooks, cross-asset themes and rapid alerts on material dislocations.",
    span: "md:col-span-5",
  },
  {
    id: "education",
    icon: GraduationCap,
    num: "04",
    title: "Structured FX Trader Education",
    body:
      "A structured education program delivering monthly modules, decks and assessments to sharpen desk and client capability.",
    span: "md:col-span-7",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-black py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={VIEWPORT_LG}
          className="max-w-3xl mb-16 md:mb-20"
        >
          <motion.p
            variants={fadeUp}
            className="font-mono-accent text-[11px] md:text-sm tracking-[0.28em] uppercase text-[#737373] mb-6"
          >
            Capabilities
          </motion.p>
          <motion.h2
            variants={fadeUp}
            data-testid="services-heading"
            className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight text-white"
          >
            A single, discreet partner across the institutional value chain.
          </motion.h2>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={VIEWPORT_SM}
          className="grid grid-cols-1 md:grid-cols-12 gap-4"
        >
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.id}
                variants={fadeUp}
                data-testid={`service-card-${s.id}`}
                className={`group relative ${s.span} bg-[#0A0A0A] border border-white/10 p-8 md:p-10 transition-colors duration-500 hover:border-white/30`}
              >
                <div className="flex items-start justify-between mb-8">
                  <Icon
                    className="w-7 h-7 text-white/70 group-hover:text-white transition-colors duration-500"
                    strokeWidth={1.4}
                  />
                  <span className="font-mono-accent text-xs tracking-[0.2em] text-[#525252]">
                    {s.num}
                  </span>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-medium tracking-tight text-white mb-4">
                  {s.title}
                </h3>
                <p className="text-sm md:text-base leading-relaxed text-[#A3A3A3] max-w-xl">
                  {s.body}
                </p>
              </motion.article>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
